import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent implements OnInit {
    public isConfirmed = false;
    public confirmationQuestion;
    public confirmationDetails;

    close: Function;

    constructor() {}

    ngOnInit() {}

    public onYes() {
        this.isConfirmed = true;
        this.close();
    }

    onNo() {
        this.isConfirmed = false;
        this.close();
    }
}
